import { useNavigate } from 'react-router-dom';
import { useFollow } from '../hooks/useFollow';

export default function FollowButton({ targetUserId, size = 'md' }) {
  const { following, loading, toggling, error, toggle } = useFollow(targetUserId);
  const navigate = useNavigate();

  const pad   = size === 'sm' ? '6px 16px'  : '9px 22px';
  const font  = size === 'sm' ? 12          : 14;

  // A signed-out visitor goes to sign up, the same place the navbar's
  // "Sign up" button sends them (Navbar.jsx). Sign-up has no way back to
  // this profile afterwards, so nothing is passed along.
  async function onClick() {
    const result = await toggle();
    if (result?.signedOut) navigate('/signup');
  }

  if (loading) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 'var(--space-xs)' }}>
      <button
        onClick={onClick}
        disabled={toggling}
        style={{
          padding: pad,
          fontSize: font,
          fontWeight: 700,
          borderRadius: 'var(--radius-10)',
          border: following ? '1.5px solid var(--brand-sand)' : '1.5px solid var(--neutral-800)',
          background: following ? 'var(--brand-white)' : 'var(--neutral-800)',
          color: following ? 'var(--neutral-600)' : 'var(--brand-white)',
          cursor: toggling ? 'wait' : 'pointer',
          opacity: toggling ? 0.7 : 1,
          transition: 'all 0.15s',
          fontFamily: 'var(--font-body)',
          whiteSpace: 'nowrap',
        }}
        onMouseEnter={e => {
          if (!toggling && following) {
            e.currentTarget.textContent = 'Unfollow';
            e.currentTarget.style.borderColor = '#fca5a5';
            e.currentTarget.style.color = '#dc2626';
          }
        }}
        onMouseLeave={e => {
          if (!toggling && following) {
            e.currentTarget.textContent = '✓ Following';
            e.currentTarget.style.borderColor = '#e8e4dc';
            e.currentTarget.style.color = '#57534e';
          }
        }}
      >
        {toggling ? '...' : following ? '✓ Following' : '+ Follow'}
      </button>
      {error && (
        <span role="alert" style={{ fontSize: 'var(--font-size-xs)', color: 'var(--feedback-error)', whiteSpace: 'nowrap' }}>
          {error}
        </span>
      )}
    </div>
  );
}